import {
  Container,
  NavTableCell,
  Page,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@fideus-ui/core";
import { createFileRoute } from "@tanstack/react-router";
import { useQuery, useTRPC } from "../../../_app/api";
import { useTranslation } from "../../../_app/i18n";
import { translations } from "../../../companies/review/translations";

export const Route = createFileRoute("/beratung/$taxAdvisoryId/reviews")({
  loader: async ({
    context: { queryClient, trpc },
    params: { taxAdvisoryId },
  }) => {
    void queryClient.ensureQueryData(
      trpc.taxAdvisorReviews.listOpenTaxAdvisorReviews.queryOptions({
        taxAdvisoryId,
      })
    );
  },
  component: ReviewsRoute,
});

function ReviewsRoute() {
  const t = useTranslation(translations);
  const { taxAdvisoryId } = Route.useParams();
  const trpc = useTRPC();

  const { data: openReviews } = useQuery(
    trpc.taxAdvisorReviews.listOpenTaxAdvisorReviews.queryOptions({
      taxAdvisoryId,
    })
  );

  const reviews = openReviews ?? [];

  return (
    <Page maxWidth={false}>
      <Container>
        <Typography variant="h3" component="h1" gutterBottom>
          {t("openReviewsHeading")}
        </Typography>

        {reviews.length === 0 ? (
          <Paper sx={{ p: 3 }}>
            <Typography color="text.secondary">{t("noOpenReviews")}</Typography>
          </Paper>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t("companyColumn")}</TableCell>
                  <TableCell>{t("yearColumn")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reviews.map((review) => (
                  <TableRow key={review.reviewId}>
                    <NavTableCell
                      to="/beratung/$taxAdvisoryId/unternehmen/$companyId/review"
                      params={{
                        taxAdvisoryId,
                        companyId: review.companyId,
                      }}
                      search={{ jahr: review.year }}
                    >
                      {review.companyName}
                    </NavTableCell>
                    <NavTableCell
                      to="/beratung/$taxAdvisoryId/unternehmen/$companyId/review"
                      params={{
                        taxAdvisoryId,
                        companyId: review.companyId,
                      }}
                      search={{ jahr: review.year }}
                    >
                      {review.year}
                    </NavTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Container>
    </Page>
  );
}
